import * as React from 'react'
import {translateCountryName} from "@ui-seeker/utils"

import LabelCountry from "../../LabelCountry";
import {Box} from "@mui/material";


export default function retailerWithoutCountryColumn() {
    return [{
		name: 'country', label: 'Country',
		options: {
			display: 'excluded',
			customBodyRowRender: v => translateCountryName(v)
		}
	},{
        name: 'retailer', label: 'Retailer',
        options: {
			headerAlign: 'left',
            customBodyRowRenderLite: (value, { country, siteURL }) => <Box className={value === 'All' ? 'is-all' : ''}>
					<LabelCountry
					country={country}
					label={value}
					url={siteURL}
				/>
			</Box>
        }
    }]
}